var _path, _path2, _path3, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealTimeSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 20v-16c0-1.657 1.343-3 3-3h12.5c.944 0 1.833.445 2.4 1.2l1.2 1.6c.567.755 1.456 1.2 2.4 1.2h21.5c1.657 0 3 1.343 3 3v8s-1 4-1 4z",
    fill: "#69adfe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43 19v-9c0-.552-.448-1-1-1h-36c-.552 0-1 .448-1 1v9z",
    fill: "#e8ecef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m38 43h6c1.657 0 3-1.343 3-3v-24c0-1.657-1.343-3-3-3h-12.5c-.944 0-1.833.445-2.4 1.2l-1.2 1.6c-.567.755-1.456 1.2-2.4 1.2h-21.5c-1.657 0-3 1.343-3 3v20c0 1.657 1.343 3 3 3z",
    fill: "#8dd1fe"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    fill: "#61c161",
    r: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.707 36.293c-.391-.391-1.023-.391-1.414 0l-1.361 1.361c-.68-7.09-6.666-12.654-13.932-12.654-5.239 0-9.999 2.889-12.422 7.538-.255.489-.065 1.094.424 1.349.491.257 1.094.066 1.349-.425 2.078-3.985 6.158-6.462 10.649-6.462 6.101 0 11.141 4.579 11.893 10.479l-1.186-1.186c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l3 3c.195.195.451.293.707.293s.512-.098.707-.293l3-3c.391-.391.391-1.023 0-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.997 44.113c-.492-.258-1.095-.065-1.349.425-2.077 3.985-6.157 6.462-10.648 6.462-6.101 0-11.141-4.579-11.893-10.479l1.186 1.186c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-3-3c-.391-.391-1.023-.391-1.414 0l-3 3c-.391.391-.391 1.023 0 1.414s1.023.391 1.414 0l1.361-1.361c.68 7.09 6.666 12.654 13.932 12.654 5.239 0 9.999-2.889 12.422-7.538.255-.489.065-1.094-.425-1.349z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeSync);
export default __webpack_public_path__ + "static/media/real-time-sync.6116f2c173e0a072914217b786fc6ace.svg";
export { ForwardRef as ReactComponent };